import store from '@/store';

export function getBetName(bet) {
  const keyname = bet?.bet?.titleKeyName;
  const betName = keyname
    ? store.getters.getTranslation(keyname)
    : bet?.bet?.title;

  if (keyname === 'ngs.keno_bet_name' || keyname === 'bet_name') {
    return `${betName} ${bet?.type}`;
  } else if (keyname === 'ngs.keno_bet_system' || keyname === 'bet_system') {
    return `${betName} ${bet?.system}/${bet?.type}`;
  }

  return betName;
}

export function getOutcomeName(bet) {
  const keyname = bet?.outcome?.titleKeyName;

  return keyname ? store.getters.getTranslation(keyname) : bet?.outcome?.title;
}

export default { getBetName, getOutcomeName };
